import { render } from "./asset.vue?vue&type=template&id=5e7007fc&scoped=true"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"

import "./asset.vue?vue&type=style&index=0&id=5e7007fc&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7007fc"],['__file',"vendor/vvg/forum/resources/vue/components/form/asset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e7007fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e7007fc', __exports__)) {
    console.log('reload')
    api.reload('5e7007fc', __exports__)
  }
  
  module.hot.accept("./asset.vue?vue&type=template&id=5e7007fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('5e7007fc', render)
  })

}


export default __exports__